import React from 'react';
import {useParams} from 'react-router-dom';
import {Member} from './Member';

export const MemberScene: React.FC = () => {
  const {teamId, id} = useParams<{teamId: string; id: string}>();
  return <Member teamId={parseInt(teamId)} memberId={parseInt(id)} />;
};

export * from './Member';
export * from './hooks';
